import angular from 'angular';
import { IPagamentoPonto } from './../models/pagamentoponto.model';
import { IFolhaPonto } from '../models/folhaponto.model';
import { LoadParams } from '../../../../shared/models/loadparams.model';

export class PagamentosPontoService {
	static $inject = ['$http', 'nsjRouting', '$rootScope', '$q'];

	public entity:  IFolhaPonto;
	public entities: Array< IFolhaPonto> = [];
	public loaded: boolean = false;
	public constructors: any = {};
	public after: any = {};
	public filters: any = {};
	public loadParams: LoadParams;
	public loading_deferred: any = null;
	public filter: any = '';

	constructor(
		public $http: angular.IHttpService,
		public nsjRouting: any,
		public $rootScope: angular.IRootScopeService,
		public $q: angular.IQService,
	) {
		this.loadParams = new LoadParams();
	}

	reload(): Array< IFolhaPonto> {
		if (this.loading_deferred) {
			this.loading_deferred.resolve();
		}

		this.loadParams.finished = false;
		this.loadParams.to_load = 1;
		this.after = {};
		this.loaded = false;
		this.entities.length = 0;
		this.loadParams.busy = false;

		return this.load();
	}

    search(filter: any = undefined): Array<any>  {
        if (typeof filter !== 'undefined') {
            this.filter = filter.search;
            Object.keys(this.filters).forEach((k: any) => { delete this.filters[k]; });
            for (var fil in filter.filters) {
                if (fil.indexOf('.') > -1) {
                    var filterSplit = fil.split('.');
                    this.filters[filterSplit[0]] = {};
                    this.filters[filterSplit[0]][filterSplit[1]] = filter.filters[fil];
                } else {
                    this.filters[fil] = filter.filters[fil];
                }
            }
        }

        return this.reload();
    }

	_load(constructors: any, offset: any, filter: any): angular.IHttpPromise<any> {
		this.loading_deferred = this.$q.defer();

		return this.$q((resolve: any, reject: any) => {
			this.$http({
				method: 'GET',
				url: this.nsjRouting.generate('ponto_pagamentoslancamentos_relatoriopagamento', angular.extend({}, constructors, { 'offset': offset, 'filter': filter }, this.filters), true),
				timeout: this.loading_deferred.promise
			})
			.then((response: any) => {
				resolve(response.data);
			})
			.catch((response: any) => {
				reject(response);
			});
		});
	}

	load(): Array< IFolhaPonto> {
		if (!this.loadParams.busy && !this.loadParams.finished && this.loadParams.to_load > 0) {
			this.loadParams.busy = true;

			this._load(this.constructors, this.after, this.filter)
				.then((data: any): void => {
					if (data.length > 0) {
						for (var i = 0; i < data.length; i++) {
							this.entities.push(data[i]);
						}
					}

					this.loadParams.finished = true;
					this.$rootScope.$broadcast('pagamentoslancamentos_relatoriopagamento_list_finished', this.entities);

					this.loaded = true;
					this.loadParams.to_load--;

                    this.$rootScope.$broadcast('pagamentoslancamentos_relatoriopagamento_loaded', this.entities);
				})
				.catch((error: any): void => {
					if (error.xhrStatus !== 'abort') {
						this.loadParams.finished = true;
					}
				})
				.finally((): void => {
					if (this.loaded || this.loadParams.finished) {
						this.loadParams.busy = false;
					}

					this.load();
				});
		}

		return this.entities;
	}

	loadMore(): void {
		this.loadParams.to_load = 3;
		this.load();
	}

	liberarPagamentos(filterapuracao: string, ano: string, mes: string): angular.IHttpPromise<any> {
		this.loading_deferred = this.$q.defer();

		return this.$q((resolve: any, reject: any) => {
			this.$http({
				method: 'post',
				url: this.nsjRouting.generate('ponto_apuracoesponto_liberarpagamentos', {'id': filterapuracao, 'ano': ano, 'mes': mes}, true),
				timeout: this.loading_deferred.promise
			})
			.then((response: any) => {
				this.$rootScope.$broadcast('apuracoesponto_liberarpagamentos_iniciado', response);
				resolve(response.data);
			})
			.catch((response: any) => {
				this.$rootScope.$broadcast('apuracoesponto_liberarpagamentos_erro', response);
				reject(response);
			});
		});
	}

	regerarPagamentos(filterapuracao: string): angular.IHttpPromise<any> {
		this.loading_deferred = this.$q.defer();

		return this.$q((resolve: any, reject: any) => {
			this.$http({
				method: 'post',
				url: this.nsjRouting.generate('ponto_apuracoesponto_regerarpagamentos', {'id': filterapuracao}, true),
				timeout: this.loading_deferred.promise
			})
			.then((response: any) => {
				this.$rootScope.$broadcast('apuracoesponto_regerarpagamentos_iniciado', response);
				resolve(response.data);
			})
			.catch((response: any) => {
				this.$rootScope.$broadcast('apuracoesponto_regerarpagamentos_erro', response);
				reject(response);
			});
		});
	}

	regerarPagamentosIndividual(filterapuracao: string, entity: IPagamentoPonto): angular.IHttpPromise<any> {
		this.loading_deferred = this.$q.defer();

		return this.$q((resolve: any, reject: any) => {
			this.$http({
				method: 'post',
				url: this.nsjRouting.generate('ponto_apuracoesponto_regerarpagamentosindividual', {'id': filterapuracao, 'trabalhador': entity.trabalhador}, true),
				timeout: this.loading_deferred.promise
			})
			.then((response: any) => {
				this.$rootScope.$broadcast('apuracoesponto_regerarpagamentosindividual_iniciado', response);
				resolve(response.data);
			})
			.catch((response: any) => {
				this.$rootScope.$broadcast('apuracoesponto_regerarpagamentosindividual_erro', response);
				reject(response);
			});
		});
	}

	exportar(objetoExportacao: any): angular.IHttpPromise<any> {
		this.loading_deferred = this.$q.defer();
		return this.$q((resolve: any, reject: any) => {
			this.$http({
				method: 'post',
				url: this.nsjRouting.generate('ponto_pagamentoslancamentos_relatoriopagamentoexportacao', {}, true),
				data: angular.copy(objetoExportacao),
				responseType: 'blob',
				timeout: this.loading_deferred.promise
			})
			.then((response: any) => {
				this.$rootScope.$broadcast('pagamentoslancamentos_relatoriopagamentoexportacao_sucesso', response);
				resolve(response.data);
			})
			.catch((response: any) => {
				this.$rootScope.$broadcast('pagamentoslancamentos_relatoriopagamentoexportacao_erro', response);
				reject(response);
			});
		});
	}

}
